import { createGlobalStyle } from 'styled-components';
import {
  SecondaryBgColor, primaryFont, wMBold, maxWidth, retina,
} from '../Utils/utilsStyle';

const PersonStyle = createGlobalStyle`
.container-company-card{
  border-radius:16px;
  background-color:${SecondaryBgColor};
  padding: 0px 0px 16px 0px;
  .main-card-spacing {
    margin-top: 20px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
     margin-top: 8px;
    }
  }
}
.person-image-container {
  margin-top: 20px;
  .progress {
    position: relative;
    &:before {
      content: '%';
      position: absolute;
      top: 10px;
      right: 6px;
      font-family: ${primaryFont};
      font-size: 9px;
      font-weight: ${wMBold};
      z-index:1;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 8px;
         top: 5px;
         right: 4px;
      }
    }
  }
}
`;

export default PersonStyle;
